import React, { Component } from 'react'
import { connect } from 'react-redux';
import { move_to_minute } from '../actions/UserActions'
import * as GameViewMode from '../constants/GameViewMode'

class MoveToMinuteControl extends Component {

    constructor(props) {
        super(props);
        this.ProgressBarWidth = 0;
        this.TotalMinutes = window.Json.game[window.Json.game.length - 1].minute;

        // Добавленное к основному времени
        var i = window.Json.game.length - 1;
        while (window.Json.game[i].minute>88){
          i--;
        }
        this.addedTime = [];
        this.addedTime[0] = window.Json.game[i+1].D;
        // Дополнительное время: либо 0, либо 30 мин
        this.addedTime[1] = this.TotalMinutes>=120 ? 30 : 0;
        // Добавленное к дополнительному времени
        this.addedTime[2] = this.addedTime[1]>0 ? this.TotalMinutes-120 : 0;
        this.seenAddedTimes = 0;
        this.minutesToShow = 90;

        this.onClick = this.onClick.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.title = "";
    }

    componentDidMount() {
      this.calculateHtmlPositions();
      this.forceUpdate();

      window.addEventListener("resize", () => {
        this.calculateHtmlPositions();
        this.forceUpdate();
      })
    }

    calculateHtmlPositions() {
      this.ProgressBarWidth = this.ProgressBarDiv.offsetWidth;
    }

    getCurrentMinute() {
      if(this.props.currentEvent == 0)
        return 0;
      if (this.seenAddedTimes>1)
        return parseInt(window.Json.game[this.props.currentEvent-1].minute)+this.addedTime[0];  
      
      return parseInt(window.Json.game[this.props.currentEvent-1].minute);
    }

    isLastEvent() {
      return window.Json.game.length == this.props.currentEvent;
    }

    onClick(event) {
        if(event.nativeEvent.target.className != "progress_navigation" && window.gameViewMode === GameViewMode.Full) {
            var rect = event.currentTarget.getBoundingClientRect()
            var offsetX = event.clientX - rect.left;
            var targetMinute = offsetX / this.ProgressBarWidth * this.minutesToShow;
            this.props.dispatch(move_to_minute(Math.round(targetMinute)));
        }
    }

    onMouseMove(event) {
      var rect = event.currentTarget.getBoundingClientRect()
      var offsetX = event.clientX - rect.left;
      var targetMinute = offsetX / this.ProgressBarWidth * this.minutesToShow;
      this.title = Math.round(targetMinute);
      this.forceUpdate()
    }

    render() {    
        let currentMinute = this.getCurrentMinute();
        if (currentMinute>=this.minutesToShow+1){
          this.minutesToShow += this.addedTime[this.seenAddedTimes];
          this.seenAddedTimes++;
        }
        // this.minutesToShow = currentMinute<89 ? 90 : (currentMinute<=90+this.addedTime[0]? 90+this.addedTime[0]: currentMinute>120? 90+this.addedTime[0]+this.addedTime[1]+this.addedTime[2]:90+this.addedTime[0]+this.addedTime[1]);
        // let progressBarWidth = (currentMinute-1) / minutesToShow * 100;
        let progressBarWidth = (currentMinute) / this.minutesToShow * this.ProgressBarWidth;
        let gamaIsOver = (currentMinute > this.TotalMinutes) || this.isLastEvent();

        let style = {
          width: progressBarWidth + 'px'
        }
        let base = {
          width: 90/this.minutesToShow*100 + "%"
        } 
        let addedTime1 = {
          width: this.addedTime[0]/this.minutesToShow*100 + "%"
        } 
        let addedTime2 = {
          width: this.addedTime[1]/this.minutesToShow*100 + "%"
        }  
        let addedTime3 = {
          width: this.addedTime[2]/this.minutesToShow*100 + "%"
        }  

        return (<div className="row">
					<div className="col-md-12">
						<div title={this.title} id="progressBar" onMouseMove={this.onMouseMove} onClick={this.onClick} ref={(elem) => { this.ProgressBarDiv = elem; }} className="default">
							<ul>
								<li style={style} className="progress">{gamaIsOver == false ? <li className="progress_navigation" ></li> : null}</li >
                <li style={base} className="base"></li >
                {this.seenAddedTimes>=1?<li style={addedTime1} className="added1"></li >:null}
                {this.seenAddedTimes>=2?<li style={addedTime2} className="added2"></li >:null}
                {this.seenAddedTimes>=3?<li style={addedTime3} className="added1"></li >:null}
								
							</ul>
						</div>
					</div>
				</div>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        currentEvent: state.currentEvent
    };
}

export default connect(mapStateToProps)(MoveToMinuteControl)



/** WEBPACK FOOTER **
 ** ./src/components/MoveToMinuteControl.js
 **/